// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethod_container__VYKPU","content":"PaymentMethod_content__q1wiA"};